<template>
    <div>
        <div class="section-heading">
            <h4>Features</h4>
            <p>Select your desired features</p>
            <p class="w-50 mt-3">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Provident porro eligendi modi
                esse nobis id voluptates, laudantium, quibusdam quos exercitationem consectetur nemo. Quo aliquid,
                error iusto nam facilis delectus reprehenderit cupiditate repudiandae, aut et sapiente praesentium
                earum aliquam optio ex ullam impedit consectetur facere sunt quasi. Dolores sit minima error natus
                cumque illo facilis, aliquid, praesentium id odit doloremque aspernatur quasi ea non nisi, itaque
                quaerat nostrum laborum tenetur ut dolor perspiciatis tempore! Architecto, eveniet ipsam a velit
                rerum labore nihil omnis mollitia suscipit distinctio ipsa odio corrupti molestiae odit ab nulla
                minus repudiandae pariatur fugit quis. Tempore, odit soluta accusamus ipsam, tempora, repellat omnis
                accusantium.</p>
        </div>
        <div class="mt-4">
            <p class="font-weight-bold">Select your features which will help you best.</p>
            <div class="d-flex w-50 flex-wrap">
                <button class="demo-btn" :class="{ 'active': feature.isSelected }" @click="selectFeatures(feature)"
                    v-for="feature of totalFeatures" :key="feature.feature_id">
                    {{ feature.feature_name }}
                </button>
            </div>
        </div>
        <div class="mt-4">
            <p class="font-weight-bold">Want more features? Help us in improving.</p>
            <input type="text" class="demo-input" v-model="featureFeedback" placeholder="Add Feature">
        </div>
        <div class="mt-4">
            <button class="primarycolor" @click="saveSelectedSection">Save and Next</button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
    name: "Features",
    data() {
        return {
            localSelectedFeatures: [],
            sovID: "f5261b1ac5a04972a6aee24fcdcdb835",
            featureFeedback: "",
            totalSections: [
                "Features",
                "Platforms",
                "Products",
                "Product Review",
                "Frequency",
                "Category & Search Terms",
                "Pincodes"
            ],
            onlySOVFeatures: [
                "Features",
                "Platforms",
                "Frequency",
                "Category & Search Terms",
                "Pincodes"
            ],
            notSOVFeatures: [
                "Features",
                "Platforms",
                "Products",
                "Product Review",
                "Frequency",
                "Pincodes"
            ]
        }
    },
    computed: {
        ...mapState("DemoStore", ['loader', 'totalFeatures', 'selectedFeatures', 'sections', 'selectedSection'])
    },
    mounted() {
        if (this.selectedFeatures.length) {
            this.localSelectedFeatures = this.selectedFeatures.map(feat => feat.feature_id);
        }
    },
    methods: {
        ...mapActions("DemoStore", ['setDemoLoader', 'setSelectedFeatures', 'setSelectedSection', 'setSections']),
        selectFeatures(feature) {
            feature.isSelected = !feature.isSelected;
        },
        saveSelectedSection() {
            let filteredFeats = this.totalFeatures.filter(feat => feat.isSelected && feat);
            this.setSelectedFeatures(filteredFeats);
            this.localSelectedFeatures = filteredFeats.map(feat => feat.feature_id);
            
            if (this.localSelectedFeatures.length === 1 && this.localSelectedFeatures[0] === this.sovID) {
                this.setSections(this.onlySOVFeatures)
            } else if(this.localSelectedFeatures.length && this.localSelectedFeatures.includes(this.sovID)) {
                this.setSections(this.totalSections)
            } else {
                this.setSections(this.notSOVFeatures);
            }
            
            const selectedSectionIndex = this.sections.indexOf(this.selectedSection);
            
            if(!this.localSelectedFeatures.length) {
                this.$bvToast.toast(`Please select at least one feature to move forward.`, {
                    title: "Weavr Sense",
                    variant: "danger",
                    toaster: "b-toaster-bottom-center",
                    autoHideDelay: 3000
                });
                return;
            }
            
            this.setDemoLoader(true);
            const url = "/api/demo/feature";
            const payload = {
                feature_ids: filteredFeats.map(feat => feat.feature_id)
            }

            this.$http.post(url, payload).then(res => {
                this.setDemoLoader(false);
                this.$bvToast.toast(`Feature(s) saved successfully.`, {
                    title: "Weavr Sense",
                    variant: "success",
                    toaster: "b-toaster-bottom-center",
                    autoHideDelay: 3000
                });
                this.setSelectedSection(this.sections[selectedSectionIndex+1]);
            }).catch(err => {
                this.setDemoLoader(false);
                this.$bvToast.toast(`Error in saving feature.`, {
                    title: "Weavr Sense",
                    variant: "danger",
                    toaster: "b-toaster-bottom-center",
                    autoHideDelay: 3000
                });
            })
        }
    }
}
</script>

<style scoped>
.demo-input {
    padding: 4px 10px;
    border: 1px solid #EBEBEB;
    border-radius: 5px;
    color: var(--primary_brand);
}

.demo-input::placeholder {
    color: #919191;
    font-family: "Poppins", sans-serif;
}

.demo-input:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: var(--primary_brand) !important;
}

.demo-btn {
    color: #919191;
    background-color: transparent;
    border: 1px solid #EBEBEB;
    border-radius: 10px;
    padding: 6px 12px;
    margin-right: 20px;
    margin-bottom: 12px;
}

.demo-btn.active {
    color: var(--primary_brand);
    border: 1px solid var(--primary_brand);
}

.demo-btn:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: #EBEBEB !important;
}

.demo-btn.active:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: var(--primary_brand) !important;
}

.section-heading h4 {
    font-size: 18px;
    font-weight: 600;
}

.section-heading p {
    color: #5E5E5E;
    font-size: 14px;
    font-weight: 500;
}

.navigationButton {
    height: 35px;
    border: none;
    margin: 0;
    background: var(--accent_color);
    color: white;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins", sans-serif;
}

.navigationButton:hover {
    background: var(--accent_color-80);
}

.navigationButton:focus {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}

button.primarycolor {
    height: 35px;
    border: none !important;
    margin: 0;
    background: var(--primary_brand);
    color: white;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins";
}

button.primarycolor:focus {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}
</style>